/* The metrics disclosure is drawn by `RecordShell` now — the design's
   "⌄ METRICS … Click to collapse" row is the shell's anatomy (#2406), so this
   sheet no longer styles a toggle. What stays is the refusal line. */
.unavailable { margin: 0; color: var(--header-muted); }
